import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Type } from '@uswitch/spark.type';
import { getVariantPath } from '@uswitch/spark.utils';
import { Fragment, useMemo } from 'react';
import { usePaginationContext } from './context';
import { PaginationNumber } from './number';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'pagination',
  element: 'pages'
});

var createNumbersArray = function createNumbersArray(numbersLeft, currentPage, numbersRight, totalPages, displayFirstAndLastPage) {
  var pageNumbers = [];
  Array(numbersLeft).fill().forEach(function (_, index) {
    return pageNumbers.unshift(currentPage - (index + 1));
  });
  pageNumbers.push(currentPage);
  Array(numbersRight).fill().forEach(function (_, index) {
    return pageNumbers.push(currentPage + (index + 1));
  });

  if (pageNumbers[0] !== 1) {
    var secondToFirst = pageNumbers[0] === 2;

    if (!secondToFirst) {
      pageNumbers.unshift('...');
    }

    if (displayFirstAndLastPage || secondToFirst) {
      pageNumbers.unshift(1);
    }
  }

  var lastPageNumberVisible = pageNumbers.slice(-1)[0];
  var lastPageNotVisible = lastPageNumberVisible !== totalPages;

  if (lastPageNotVisible) {
    var secondToLast = pageNumbers.slice(-1)[0] === totalPages - 1;

    if (!secondToLast) {
      pageNumbers.push('...');
    }

    if (displayFirstAndLastPage || secondToLast) {
      pageNumbers.push(totalPages);
    }
  }

  return pageNumbers;
};

var getPageNumbers = function getPageNumbers(currentPage, totalPages, maxNumbersToDisplay, showFirstAndLastArrows) {
  var displayFirstAndLastPage = !showFirstAndLastArrows;
  var numbersToDisplayEachSideOfCurrent = Math.floor((maxNumbersToDisplay - 1) / 2);

  if (totalPages <= maxNumbersToDisplay) {
    return _toConsumableArray(Array(totalPages + 1).keys()).slice(1);
  }

  var numbersToDisplayLeftOfCurrent = function () {
    if (currentPage === 1) return 0;
    if (currentPage - numbersToDisplayEachSideOfCurrent < 1) return Math.abs(currentPage - 1);
    return numbersToDisplayEachSideOfCurrent;
  }();

  var numbersToDisplayRightOfCurrent = function () {
    var remainingNumbersToDistribute = maxNumbersToDisplay - 1 - numbersToDisplayLeftOfCurrent;

    if (currentPage + remainingNumbersToDistribute <= totalPages) {
      return remainingNumbersToDistribute;
    }

    return totalPages - currentPage;
  }();

  var pageNumbers = createNumbersArray(numbersToDisplayLeftOfCurrent, currentPage, numbersToDisplayRightOfCurrent, totalPages, displayFirstAndLastPage);
  return pageNumbers;
};

export var Pages = function Pages() {
  var _usePaginationContext = usePaginationContext(),
      totalPages = _usePaginationContext.totalPages,
      currentPage = _usePaginationContext.currentPage,
      maximumPageNumbersToDisplay = _usePaginationContext.maximumPageNumbersToDisplay,
      showFirstAndLastArrows = _usePaginationContext.showFirstAndLastArrows;

  var pageNumbersToDisplay = useMemo(function () {
    return getPageNumbers(currentPage, totalPages, maximumPageNumbersToDisplay, showFirstAndLastArrows);
  }, [currentPage, totalPages, maximumPageNumbersToDisplay, showFirstAndLastArrows]);
  return _jsxs(Fragment, {
    children: [_jsx("div", {
      sx: {
        variant: variantPath()
      },
      children: pageNumbersToDisplay.map(function (page) {
        return _jsx(PaginationNumber, {
          children: page
        }, page);
      })
    }), _jsx("div", {
      sx: {
        variant: variantPath('mobile')
      },
      children: _jsxs(Type.Body2, {
        children: ["Page ", currentPage, " of ", totalPages]
      })
    })]
  });
};
Pages.displayName = 'Pages';